import { RadioGroup } from '~/shared/ui/RadioGroup/RadioGroup';
import { AddingCard } from '~/features/AddingCard/AddingCard';
import { FC, ReactNode } from 'react';
import { OwnBlock } from '~/shared/ui/OwnBlock/OwnBlock';
import { cvaAddingCard } from '~/features/AddingCard/AddingCardStyles';
import { cvaCardSwitcher } from './CardSwitcherStyles';
import { useGetCards } from '~/shared/hooks/useGetCards';
import { LoadingSpinner } from '~/shared/ui/LoadingSpinner/LoadingSpinner';
//import { useUserCardsStore } from '~/shared/store/userCardsStore';

// const cards = [
//   { img: 'visa', label: '*7536', value: 'test' },
//   { img: 'mir', label: '*1236', value: 'test1' },
//   { img: 'mastercard', label: '*2241', value: 'test2' },
// ];

interface Props {
  children?: ReactNode;
  variant?: 'own' | 'default' | 'secondary' | 'third';
  text: string;
}

export const CardSwitcher: FC<Props> = ({ children, variant, text }) => {
  const { cards, isLoading } = useGetCards();
  //const { state } = useUserCardsStore();

  return isLoading ? (
    <div className="w-full pt-1.6">
      <LoadingSpinner />
    </div>
  ) : (
    <OwnBlock variant={variant} className={cvaCardSwitcher()}>
      {children}
      {cards?.length ? (
        <RadioGroup
          data={cards.map((card) => ({
            img: card.type.toLowerCase(),
            label: '*' + card.number,
            value: card.id,
            is_default: card.is_default,
          }))}
          type={variant == 'default' ? 'secondary' : 'primary'}
        />
      ) : (
        variant == 'default' && (
          <div className={cvaAddingCard({ type: 'secondary' })}>
            <span>
              Для продолжения необходимо <br />
              добавить карту
            </span>
          </div>
        )
      )}
      <AddingCard
        text={text}
        type={variant == 'default' ? 'secondary' : 'primary'}
      />
    </OwnBlock>
  );
};
